import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Context/authContext';

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  // Allowlisted public paths that should be accessible without authentication
  const pathname = location?.pathname || '';
  const isPublicPath = pathname.startsWith('/skills/blog/blog-preview/') || 
                       pathname.startsWith('/preview-product-description/') || 
                       pathname.startsWith('/preview-blog/') ||
                       pathname.startsWith('/skills/free-form-content/preview/');

  if (isPublicPath) {
    return children;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};